<template>
  <div class="team">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
      <!-- 轮播图部分 -->
      <section class="banner-section">
        <el-carousel height="538px" :interval="3500" arrow="hover">
          <el-carousel-item v-for="(slide, index) in heroSlides" :key="index">
            <div class="banner-slide" :style="{ backgroundImage: `url(${slide.image})` }">
              <div class="banner-overlay">

                <h1 class="banner-title">{{ $t(slide.title) }}</h1>
                <p class="banner-subtitle">{{ $t(slide.description) }}</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </section>

      <!-- 公司资质与荣誉 -->
      <section class="company-credentials">
        <div class="container">
          <div class="credentials-header">
            <h2 class="section-title">{{ $t('team.credentials.title') }}</h2>
          </div>

          <div class="credentials-content">
            <!-- 资质认证展示1 -->
            <div class="credentials-showcase">
              <div class="credential-item">
                <div class="credential-header">
                  <h3>{{ $t('team.credentials.item1.title') }}</h3>
                  <span class="year-badge">{{ $t('team.credentials.item1.year') }}</span>
                </div>
                <div class="credential-content">
                  <p>{{ $t('team.credentials.item1.p1') }}</p>
                  <p style="margin-top: 10px;">{{ $t('team.credentials.item1.p2') }}</p>

                </div>
              </div>


            </div>
            <!-- 资质证书展示1 -->
            <div class="certificates-display">
              <div class="certificate-card">
                <div class="certificate-title clickable-title" @click="openAnnouncementList(1)">{{
                  $t('team.credentials.certificate1.title') }}</div>
                <div class="certificate-table two-column-table">
                  <div class="table-header">
                    <span>{{ $t('team.table.two.code') }}</span>
                    <span>{{ $t('team.table.two.agencyName') }}</span>
                  </div>
                  <div class="table-row highlight">
                    <span>11767</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- 资质认证展示2 -->
            <div class="credentials-showcase">
              <div class="credential-item">
                <div class="credential-header">
                  <h3>{{ $t('team.credentials.item2.title') }}</h3>
                  <span class="certification-badge">{{ $t('team.credentials.item2.badge') }}</span>
                </div>
                <div class="credential-content">
                  <p v-html="$t('team.credentials.item2.p')"></p>
                </div>
              </div>
            </div>




            <!-- 资质证书展示 -->
            <div class="certificates-display" style="width:100%">
              <div class="certificate-card">
                <div class="certificate-title clickable-title" @click="openAnnouncementList(2)">{{
                  $t('team.credentials.certificate2.title') }}</div>
                <div class="certificate-table five-column-table">
                  <div class="table-header">
                    <span>{{ $t('team.table.five.code') }}</span>
                    <span>{{ $t('team.table.five.name') }}</span>
                    <span>{{ $t('team.table.five.license') }}</span>
                    <span>{{ $t('team.table.five.agencyName') }}</span>
                    <span>{{ $t('team.table.five.mark') }}</span>
                  </div>
                  <div class="table-row">
                    <span>11767</span>
                    <span>{{ $t('team.table.five.uname1') }}&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('team.table.five.uname11')
                    }}</span>
                    <span>11767106112.1</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                    <span>*</span>
                  </div>
                  <div class="table-row">
                    <span>11767</span>
                    <span>{{ $t('team.table.five.uname2') }}</span>
                    <span>11767153301.4</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                    <span>*</span>
                  </div>
                  <div class="table-row">
                    <span>11767</span>
                    <span>{{ $t('team.table.five.uname3') }}</span>
                    <span>11767321115.6</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                    <span></span>
                  </div>
                  <div class="table-row">
                    <span>11767</span>
                    <span>{{ $t('team.table.five.uname4') }}</span>
                    <span>11767363392.4</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                    <span></span>
                  </div>
                  <div class="table-row">
                    <span>11767</span>
                    <span>{{ $t('team.table.five.uname5') }}</span>
                    <span>11767597744.0</span>
                    <span>{{ $t('team.credentials.agencyName') }}</span>
                    <span>*</span>
                  </div>
                </div>
                <div class="certificate-title-bottom">{{ $t('team.credentials.note') }}</div>
              </div>
              <div class="credentials-showcase">
                <div class="credential-item">

                  <div class="credential-content">
                    <p>{{ $t('team.textn1') }}<span style="font-weight: bold;">{{ $t('team.textn2') }}</span>
                      {{ $t('team.textn3') }}
                    </p>
                  </div>
                </div>
              </div>
              <!-- 公司介绍文本 -->
              <div class="company-intro" style="margin-top:2rem ">
                <div class="intro-card">
                  <h3>{{ $t('team.table.six.text1') }}</h3>
                  <p>
                    {{ $t('team.table.six.text2') }}
                  </p>
                </div>
                <div class="intro-card">
                  <h3>{{ $t('team.table.six.text3') }}</h3>
                  <p> {{ $t('team.table.six.text4') }}</p>
                </div>
              </div>

            </div>

          </div>
        </div>
      </section>
      <!-- 之于行团队聘任情况及奖项荣誉 -->
      <section class="team-honors-section">
        <div class="container">
          <div class="honors-header">
            <h2 class="section-title">{{ $t('team.textn4') }}</h2>
          </div>

          <div class="honors-content">
            <!-- 荣誉展示卡片 -->
            <div class="honors-showcase">
              <div class="honor-item">
                <div class="honor-header">
                  <h3>{{ $t('team.textn5') }}</h3>
                  <span class="year-range-badge">2017-2024</span>
                </div>
                <div class="honor-content">
                  <div class="honor-list">
                    <div class="honor-entry" v-for="(honor, index) in teamHonors" :key="index">
                      <span class="honor-year">{{ honor.year }}{{ $t('team.zhuanye.year17') }}</span>
                      <span class="honor-text">{{ $t(honor.fullText) }}<span style="font-weight: bold;">{{
                        $t(honor.fullText1) }}</span>{{ $t(honor.fullText2) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      <!-- 团队类别切换按钮 -->
      <section class="team-category-section">
        <div class="container">
          <div class="team-category-buttons">
            <button v-for="(category, index) in teamCategories" :key="index"
              :class="['category-btn', { active: currentCategory === category.id }]"
              @click="changeTeamCategory(category.id)">
              <span> {{ $t(category.name) }}</span>
            </button>
          </div>
        </div>
      </section>

      <!-- 团队成员列表 -->
      <section class="team-members">
        <div class="container">

          <!-- 商标团队特殊展示 -->
          <div v-if="currentCategory === 'trademark'" class="trademark-team-display">
            <div class="trademark-description">
              <p style="font-weight: bold;">{{ $t(teamMembers.trademark.description) }} </p>
              <p><span style="font-weight: bold;">{{ $t('team.textnb2') }}</span>{{ $t('team.textnb3') }}<span
                  style="font-weight: bold;">{{ $t('team.textnb4') }}</span>{{ $t('team.textnb5') }}</p>
            </div>

            <!-- 主要图片展示 -->
            <div class="trademark-main-card">
              <div class="trademark-main-images">
                <img v-for="(image, index) in teamMembers.trademark.mainImages" :key="'main-' + index" :src="image"
                  :alt="'商标团队主图' + (index + 1)" class="main-image">
              </div>
              <div class="trademark-caption">{{ $t('team.textn6') }}</div>
            </div>

            <!-- 图片画廊 - 左右滑动 -->
            <div class="trademark-gallery">
              <div class="trademark-gallery-grid">
                <div class="gallery-card" v-for="(image, index) in teamMembers.trademark.galleryImages"
                  :key="'grid-' + index">
                  <img :src="image" :alt="'商标团队图片' + (index + 1)" class="gallery-image">
                </div>
              </div>
              <div class="gallery-caption">{{ $t('team.textn7') }}</div>
            </div>
          </div>

          <!-- 其他团队正常展示 -->
          <div v-else class="team-grid">
            <div class="team-card" v-for="(member, index) in displayedTeamMembers" :key="index">
              <div class="team-image">
                <img :src="member.image" :alt="member.name" class="member-image">
              </div>
              <div class="team-info">
                <div class="member-title">
                  {{ member.title }}
                  <span class="member-subtitle" v-if="member.subtitle">{{ member.subtitle }}</span>
                </div>
                <h3 class="member-name">{{ member.name }}</h3>
                <div class="member-lang" v-if="member.workLang">{{ $t('wklang') }}{{ member.workLang }}</div>
                <div class="member-education" v-if="member.coreIntro&&member.coreIntro.length > 0">

                  <p v-for="(item, i) in member.coreIntro" :key="i">{{ item }}</p>
                </div>
                <div class="member-education" v-if="!member.coreIntro||member.coreIntro.length === 0">

                  <p v-for="(item, i) in member.education" :key="i">{{ item }}</p>
                </div>
                <div class="member-contact" @click="openMemberResume(member)">
                  <a href="javascript:void(0)" class="contact-btn">{{ $t('team.textt01') }}</a>
                </div>
              </div>
            </div>

            <!-- 如果当前类别没有成员，显示提示信息 -->
            <div class="no-members-message" v-if="displayedTeamMembers.length === 0">
              <p>该团队成员信息正在更新中，敬请期待...</p>
            </div>
          </div>
        </div>
      </section>
      <!-- 新增翻译团队概况 只有当 currentCategory === 'translation' 时 才显示 -->
      <section v-if="currentCategory === 'translation'" class="translation-overview-section">
        <div class="container">
          <div class="translation-overview-card">
            <h3 class="overview-title">{{ $t('teamserve01') }}</h3>

            <!-- 团队基本信息 -->
            <div class="team-basic-info">
              <div class="info-grid">
                <div class="info-item">
                  <div class="info-icon">
                    <span class="icon-number">10</span>
                  </div>
                  <div class="info-content">
                    <h4>{{ $t('teamserve02') }}</h4>
                    <p>{{ $t('teamserve03') }}<span class="highlight-text">{{ $t('teamserve04') }}</span></p>
                  </div>
                </div>

                <div class="info-item">
                  <div class="info-icon">
                    <span class="icon-number">11</span>
                  </div>
                  <div class="info-content">
                    <h4>{{ $t('teamserve05') }}</h4>
                    <p>{{ $t('teamserve06') }}<span class="highlight-text">{{ $t('teamserve07') }}</span></p>
                  </div>
                </div>

                <div class="info-item">
                  <div class="info-icon">
                    <span class="icon-number">8</span>
                  </div>
                  <div class="info-content">
                    <h4>{{ $t('teamserve08') }}</h4>
                    <p>{{ $t('teamserve09') }}<span class="highlight-text">{{ $t('teamserve10') }}</span>{{ $t('teamserve11') }}</p>
                  </div>
                </div>

                <div class="info-item">
                  <div class="info-icon">
                    <span class="icon-number">3</span>
                  </div>
                  <div class="info-content">
                    <h4>{{ $t('teamserve12') }}</h4>
                    <p>{{ $t('teamserve13') }}<span class="highlight-text">{{ $t('teamserve14') }}</span>{{ $t('teamserve15') }}</p>
                  </div>
                </div>
              </div>

              <div class="team-composition">
                <p class="composition-text">
                  {{ $t('teamserve16') }}
                </p>
              </div>
            </div>

            <!-- 专业能力介绍 -->
            <div class="professional-capabilities">
              <div class="capability-item">
                <div class="capability-header">
                  <h4>{{ $t('teamserve17') }}</h4>
                </div>
                <div class="capability-content">
                  <p>{{ $t('teamserve18') }}<span class="language-tag" v-show="$t('teamserve19')">{{ $t('teamserve19') }}</span>
                    <span class="language-tag" v-show="$t('teamserve20')">{{ $t('teamserve20') }}</span>
                    {{ $t('teamserve21') }}
                    <span class="language-tag" v-show="$t('teamserve22')">{{ $t('teamserve22') }}</span>{{ $t('teamserve23') }}
                    <span class="language-tag" v-show="$t('teamserve24')">{{ $t('teamserve24') }}</span>
                    {{ $t('teamserve25') }}<span class="highlight-number"> {{ $t('teamserve26') }}</span>
                  </p>
                </div>
              </div>

              <div class="capability-item">
                <div class="capability-header">
                  <h4> {{ $t('teamserve27') }}</h4>
                </div>
                <div class="capability-content">
                  <p> {{ $t('teamserve28') }}<span class="highlight-number"> {{ $t('teamserve29') }}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <!-- 新增翻译团队 服务内容 只有当 currentCategory === 'translation' 时 才显示 -->
      <section v-if="currentCategory === 'translation'" class="translation-services-section">
        <div class="container">
          <div class="services-layout">
            <!-- 左侧：专利、司法及技术文献翻译 -->
            <div class="service-category-card">
              <div class="category-header">
                <h3 class="category-title"> {{ $t('teamserve30') }}</h3>
              </div>

              <div class="service-grid">
                <div class="service-column">
                  <div class="service-item">{{ $t('teamserve31') }}</div>
                  <div class="service-item">{{ $t('teamserve33') }}</div>
                  <div class="service-item">{{ $t('teamserve35') }}</div>
                  <div class="service-item">{{ $t('teamserve37') }}</div>
                  <div class="service-item">{{ $t('teamserve39') }}</div>
                  <div class="service-item">{{ $t('teamserve41') }}</div>
                </div>

                <div class="service-column">
                  <div class="service-item">{{ $t('teamserve32') }}</div>
                  <div class="service-item">{{ $t('teamserve34') }}</div>
                  <div class="service-item">{{ $t('teamserve36') }}</div>
                  <div class="service-item">{{ $t('teamserve38') }}</div>
                  <div class="service-item">{{ $t('teamserve40') }}</div>
                </div>
              </div>

              <!-- 翻译语言 -->
              <div class="languages-section">
                <h4 class="languages-title">{{ $t('teamserve48') }}</h4>
                <div class="languages-tags">
                  <span class="language-tag primary">{{ $t('teamserve49') }}</span>
                  <span class="language-tag primary">{{ $t('teamserve50') }}</span>
                </div>
              </div>
            </div>

            <!-- 右侧：本地化流程 -->
            <div class="service-category-card">
              <div class="category-header">
                <h3 class="category-title">{{ $t('teamserve42') }}</h3>
              </div>

              <div class="localization-grid">
                <div class="localization-item">
                  <div class="step-number">1</div>
                  <div class="step-content">{{ $t('teamserve43') }}</div>
                </div>

                <div class="localization-item">
                  <div class="step-number">2</div>
                  <div class="step-content">{{ $t('teamserve44') }}</div>
                </div>

                <div class="localization-item">
                  <div class="step-number">3</div>
                  <div class="step-content">{{ $t('teamserve45') }}</div>
                </div>

                <div class="localization-item">
                  <div class="step-number">4</div>
                  <div class="step-content">{{ $t('teamserve46') }}</div>
                </div>

                <div class="localization-item">
                  <div class="step-number">5</div>
                  <div class="step-content">{{ $t('teamserve47') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新增翻译团队 我们的客户 只有当 currentCategory === 'translation' 时 才显示 -->
      <section v-if="currentCategory === 'translation'" class="translation-clients-section">
        <div class="container">
          <!-- 大标题 -->
          <div class="clients-main-header">
            <h2 class="main-title">{{ $t('teamserve51') }}</h2>
            <div class="main-underline"></div>
          </div>

          <div class="clients-layout">
            <!-- 德语项目客户 -->
            <div class="client-category-card">
              <div class="category-header">
                <h3 class="category-title">{{ $t('teamserve52') }}</h3>
              </div>

              <div class="clients-grid">
                <div class="client-item" v-for="(client, index) in germanClients" :key="'german-' + index">
                  <div class="client-logo">
                    <img :src="client.logo" :alt="client.name" class="logo-image">
                  </div>
                  <div class="client-name">{{ $t(client.name) }}  </div>
                </div>
              </div>
            </div>

            <!-- 英语项目客户 -->
            <div class="client-category-card">
              <div class="category-header">
                <h3 class="category-title">{{ $t('teamserve53') }}</h3>
              </div>

              <div class="clients-grid">
                <div class="client-item" v-for="(client, index) in englishClients" :key="'english-' + index">
                  <div class="client-logo">
                    <img :src="client.logo" :alt="client.name" class="logo-image">
                  </div>
                  <div class="client-name">{{ $t(client.name) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 新增翻译团队 案例一 只有当 currentCategory === 'translation' 时 才显示 -->
      <!-- WIPOTEC合作案例 -->
      <section v-if="currentCategory === 'translation'" class="wipotec-case-section">
        <div class="container">
          <div class="wipotec-case-card">
            <h3 class="case-title">{{ $t('teamserve54') }}</h3>

            <div class="case-layout">
              <!-- 左侧：公司Logo -->
              <div class="case-left">
                <div class="company-logo-container">
                  <img src="@/assets/images/teamimg/fanyekehu/anli02.png" alt="WIPOTEC公司Logo" class="company-logo" />
                </div>
              </div>

              <!-- 右侧：公司介绍 -->
              <div class="case-right">
                <div class="company-intro">
                  <p>
                    <strong> </strong>{{ $t('teamserve55') }}<span
                      class="highlight-text">{{ $t('teamserve56') }}</span> {{ $t('teamserve57') }}
                  </p>

                  <p>
                    <strong></strong>    {{ $t('teamserve58') }}
                  </p>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>


      <!-- 新增翻译团队 案例二华中科技大学  只有当 currentCategory === 'translation' 时 才显示 -->
      <section v-if="currentCategory === 'translation'" class="hust-case-section">
        <div class="container">
          <div class="hust-case-card">
            <h3 class="case-title">{{ $t('teamserve59') }}</h3>

            <div class="case-layout">
              <!-- 左侧：大学Logo -->
              <div class="case-left">
                <div class="university-logo-container">
                  <img src="@/assets/images/teamimg/fanyekehu/anli03.png" alt="华中科技大学Logo" class="university-logo" />
                </div>
              </div>

              <!-- 右侧：合作介绍 -->
              <div class="case-right">
                <div class="university-intro">
                  <p>
                    {{ $t('teamserve60') }}<span class="highlight-text">{{ $t('teamserve61') }}</span>{{ $t('teamserve62') }}<span
                      class="highlight-text">{{ $t('teamserve63') }}</span>{{ $t('teamserve64') }}
                    <span class="highlight-text">{{ $t('teamserve65') }}</span>
                  </p>

                  <p>
                       {{ $t('teamserve66') }}
                  </p>
                </div>
              </div>
            </div>

            <!-- 合作成果统计 -->
            <div class="cooperation-stats">
              <h4 class="stats-title"> {{ $t('teamserve67') }}</h4>
              <div class="stats-grid">
                <div class="stat-item">
                  <div class="stat-number"> {{ $t('teamserve68') }}</div>
                  <div class="stat-label"> {{ $t('teamserve69') }}</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number"> {{ $t('teamserve70') }}</div>
                  <div class="stat-label"> {{ $t('teamserve71') }}</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number"> {{ $t('teamserve72') }}</div>
                  <div class="stat-label"> {{ $t('teamserve73') }}</div>
                </div>
                <div class="stat-item">
                  <div class="stat-number"> {{ $t('teamserve74') }}</div>
                  <div class="stat-label"> {{ $t('teamserve75') }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 翻译客户反馈——本地化翻译 -->
      <section v-if="currentCategory === 'translation'" class="feedback-section">
        <div class="container">
          <div class="feedback-card">
            <h3 class="feedback-title">{{ $t('teamserve76') }}</h3>

            <div class="feedback-layout">
              <!-- 左侧：宝马公司反馈 -->
              <div class="feedback-left">
                <div class="feedback-item">
                  <div class="feedback-header">
                    <div class="feedback-company-icon">•</div>
                    <h4 class="feedback-company-name">{{ $t('teamserve77') }}</h4>
                  </div>
                  <div class="feedback-content">
                    <p class="feedback-text-de">
                      {{ $t('teamguding1') }}
                    </p>
                    <p class="feedback-text-cn">
                      <span class="feedback-highlight"> {{ $t('teamserve78') }}</span>
                    </p>
                    <p class="feedback-text-de">
                       {{ $t('teamguding2') }}
                    </p>
                    <p class="feedback-text-cn">
                      <span class="feedback-highlight"> {{ $t('teamserve79') }}</span>
                    </p>
                  </div>
                </div>

                <div class="feedback-item">
                  <div class="feedback-header">
                    <div class="feedback-company-icon">•</div>
                    <h4 class="feedback-company-name">{{ $t('teamserve80') }}</h4>
                  </div>
                  <div class="feedback-content">
                    <p class="feedback-text-de">
                      
                        {{ $t('teamguding3') }}
                    </p>
                    <p class="feedback-text-cn">
                      <span class="feedback-highlight">{{ $t('teamserve81') }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- 右侧：某瑞士事务所反馈 -->
              <div class="feedback-right">
                <div class="feedback-item">
                  <div class="feedback-header">
                    <div class="feedback-company-icon">•</div>
                    <h4 class="feedback-company-name">{{ $t('teamserve82') }}</h4>
                  </div>
                  <div class="feedback-content">
                    <p class="feedback-text-cn">
                       <span class="feedback-highlight">{{ $t('teamserve83') }}</span>{{ $t('teamserve84') }}<span class="feedback-highlight">
                        {{ $t('teamserve85') }}</span>{{ $t('teamserve86') }}<span class="feedback-highlight">{{ $t('teamserve87') }}</span>  {{ $t('teamserve88') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 新增翻译团队 案例三 翻译客户反馈 只有当 currentCategory === 'translation' 时 才显示 -->


      <!-- 商标团队案例：面对强势异议方的商标争议解决之道 -->
      <section class="shangbiaoanlia" v-if="currentCategory === 'trademark'">
        <div class="trademark-case-card">
          <h3 class="case-title">{{ $t('team.textn8') }}</h3>
          <div class="case-layout">
            <div class="case-left">
              <img src="@/assets/images/teamimg/shangbiao/anli01.png" alt="商标争议解决之道案例" class="case-image" />
            </div>
            <div class="case-right">
              <p>{{ $t('team.textn9') }}
              </p>
              <p>
                {{ $t('team.textn10') }}
              </p>
              <p>
                {{ $t('team.textn11') }}
              </p>
              <p>
                {{ $t('team.textn12') }}
              </p>
            </div>
          </div>
        </div>
      </section>
      <!-- 商标团队案例：|为国际客户提供值得信赖的商标法律顾问服务-->
      <div v-if="currentCategory === 'trademark'" class="trademark-international-card">
        <h3 class="case-title">{{ $t('team.textn13') }}</h3>
        <div class="international-grid">
          <div class="international-item" v-for="(img, idx) in teamMembers.trademark.internationalImages"
            :key="'intl-' + idx">
            <img :src="img" alt="国际客户商标顾问案例" class="international-image" />
          </div>
        </div>
        <p class="international-desc">
          {{ $t('team.textn14') }}
        </p>
      </div>

    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import axios from 'axios'
export default {
  name: 'Team',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      heroSlides: [
        {
          title: 'team.banner.title',
          description: 'team.banner.subtitle',
          image: require('@/assets/images/teamimg/teamhomebg.png')
        }
      ],
      currentCategory: 'core',
      teamHonors: [
        {
          year: '2017',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl05c'
        },
        {
          year: '2018',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl06c'
        },
        {
          year: '2020',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl07c'
        },
        {
          year: '2021',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl08c'
        },
        {
          year: '2021',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl09c'
        },
        {
          year: '2022',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl10c'
        },
        {
          year: '2022',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl11c'
        },
        {
          year: '2023',
          fullText: 'team.zhuanye.dl02c',
          fullText1: 'team.zhuanye.dname2',
          fullText2: 'team.zhuanye.dl12c'
        },
        {
          year: '2023',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl13c'
        },
        {
          year: '2023',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl14c'
        },
        {
          year: '2024',
          fullText: 'team.zhuanye.dl01c',
          fullText1: 'team.zhuanye.dname1',
          fullText2: 'team.zhuanye.dl15c'
        },
        {
          year: '2024',
          fullText: 'team.zhuanye.dl02c',
          fullText1: 'team.zhuanye.dname3',
          fullText2: 'team.zhuanye.dl16c'
        },
        {
          year: '2024',
          fullText: 'team.zhuanye.dl03c',
          fullText1: 'team.zhuanye.dname4',
          fullText2: 'team.zhuanye.dl16c'
        },
        {
          year: '2024',
          fullText: 'team.zhuanye.dl04c',
          fullText1: 'team.zhuanye.dname5',
          fullText2: 'team.zhuanye.dl16c'
        }
      ], // 默认显示专利团队
      teamCategories: [
        {
          id: 'core',
          name: 'team.core',
          icon: require('@/assets/images/teamimg/icons/patent-icon.png')
        },
        {
          id: 'patent',
          name: 'team.patent',
          icon: require('@/assets/images/teamimg/icons/patent-icon.png')
        },
        {
          id: 'trademark',
          name: 'team.trademark',
          icon: require('@/assets/images/teamimg/icons/process-icon.png')
        },
        {
          id: 'foreign',
          name: 'team.foreign',
          icon: require('@/assets/images/teamimg/icons/foreign-icon.png')
        },
        {
          id: 'translation',
          name: 'team.translation',
          icon: require('@/assets/images/teamimg/icons/translation-icon.png')
        },
        {
          id: 'process',
          name: 'team.process',
          icon: require('@/assets/images/teamimg/icons/process-icon.png')
        }
      ],
      teamMembers: {
        trademark: {
          description: 'team.textnb1',

          mainImages: [
            require('@/assets/images/teamimg/shangbiao/11.jpg'),
            require('@/assets/images/teamimg/shangbiao/12.jpg')
          ],
          galleryImages: [
            require('@/assets/images/teamimg/shangbiao/21.jpg'),
            require('@/assets/images/teamimg/shangbiao/22.jpg'),
            require('@/assets/images/teamimg/shangbiao/23.jpg'),
            require('@/assets/images/teamimg/shangbiao/24.jpg'),
            require('@/assets/images/teamimg/shangbiao/25.jpg'),
            require('@/assets/images/teamimg/shangbiao/26.jpg')
          ],
          internationalImages: [
            require('@/assets/images/teamimg/shangbiao/anli02.png'),
            require('@/assets/images/teamimg/shangbiao/anli03.png'),
            require('@/assets/images/teamimg/shangbiao/anli04.png'),
            require('@/assets/images/teamimg/shangbiao/anli05.png'),
            require('@/assets/images/teamimg/shangbiao/anli06.png'),
            require('@/assets/images/teamimg/shangbiao/anli07.png')
          ]
        },
        core: [ ],
        patent: [
          // 专利团队成员数据
        ],
        foreign: [
          // 涉外团队成员数据
        ],
        translation: [
          // 翻译团队成员数据
        ],
        process: [
        ]
      },
      // 德语项目客户数组
      germanClients: [
        { name: 'tdeyu.name1', logo: require('@/assets/images/teamimg/fanyekehu/baoma.png') },
        { name: 'tdeyu.name2', logo: require('@/assets/images/teamimg/fanyekehu/曼集团.png') },
        { name: 'tdeyu.name3', logo: require('@/assets/images/teamimg/fanyekehu/万通公司.png') },
        { name: 'tdeyu.name4', logo: require('@/assets/images/teamimg/fanyekehu/西克集团.png') },
        { name: 'tdeyu.name5', logo: require('@/assets/images/teamimg/fanyekehu/通快集团.png') },
        { name: 'tdeyu.name6', logo: require('@/assets/images/teamimg/fanyekehu/WANZL旺众.png') },
        { name: 'tdeyu.name7', logo: require('@/assets/images/teamimg/fanyekehu/GWK.png') },
        { name: 'tdeyu.name8', logo: require('@/assets/images/teamimg/fanyekehu/博世.png') },
        { name: 'tdeyu.name9', logo: require('@/assets/images/teamimg/fanyekehu/梅施汽车服务.png') },
        { name: 'tdeyu.name10', logo: require('@/assets/images/teamimg/fanyekehu/Festo.png') },
        { name: 'tdeyu.name11', logo: require('@/assets/images/teamimg/fanyekehu/佛克公司.png') },
        { name: 'tdeyu.name12', logo: require('@/assets/images/teamimg/fanyekehu/FAM集团.png') }
      ],
      // 英语项目客户数组
      englishClients: [
        { name: 'tyingyu.name1', logo: require('@/assets/images/teamimg/fanyekehu/谷歌公司.png') },
        { name: 'tyingyu.name2', logo: require('@/assets/images/teamimg/fanyekehu/费森尤斯医疗.png') },
        { name: 'tyingyu.name3', logo: require('@/assets/images/teamimg/fanyekehu/德国普旭公司.png') },
        { name: 'tyingyu.name4', logo: require('@/assets/images/teamimg/fanyekehu/隐适美.png') },
        { name: 'tyingyu.name5', logo: require('@/assets/images/teamimg/fanyekehu/宾利汽车公司.png') },
        { name: 'tyingyu.name6', logo: require('@/assets/images/teamimg/fanyekehu/LAPP缆普集团.png') },
        { name: 'tyingyu.name7', logo: require('@/assets/images/teamimg/fanyekehu/哈伯斯特.png') },
        { name: 'tyingyu.name8', logo: require('@/assets/images/teamimg/fanyekehu/Moleskine.png') },
        { name: 'tyingyu.name9', logo: require('@/assets/images/teamimg/fanyekehu/锋翔科技.png') },
        { name: 'tyingyu.name10', logo: require('@/assets/images/teamimg/fanyekehu/DxO.png') },
        { name: 'tyingyu.name11', logo: require('@/assets/images/teamimg/fanyekehu/PrimaLoft.png') },
        { name: 'tyingyu.name12', logo: require('@/assets/images/teamimg/fanyekehu/简森集团.png') }
      ],
      // WIPOTEC授权专利数据
      wipotecPatents: [
        { no: 1, title: 'Schaltschrankanordnung', applicationNo: '202111567431.2', status: 'Granted' },
        { no: 2, title: 'Inspektionseinrichtung und Zuführvorrichtung für solche Inspektionseinrichtung', applicationNo: '202420948805.8', status: 'Granted' },
        { no: 3, title: 'Scannereinheit und Inspektionsvorrichtung mit einer solchen Scannereinheit', applicationNo: '202420884903.X', status: 'Granted' },
        { no: 4, title: 'System mit Fördervorrichtung und Waage', applicationNo: '202420948844.8', status: 'Granted' },
        { no: 5, title: 'Fördervorrichtung und Transportkassette', applicationNo: '202290000593.X', status: 'Granted' },
        { no: 6, title: 'Kraftübertragungselement für eine Waage bzw. Wägezelle', applicationNo: '202111346500.7', status: 'Granted' },
        { no: 7, title: 'Modulare Umlenkeinrichtung und deren Anordnung an einer Fördereinrichtung', applicationNo: '202322677817X', status: 'Granted' },
        { no: 8, title: 'Sortierer', applicationNo: '202111438042.X', status: 'Granted' },
        { no: 9, title: 'Röntgenstrahlungsdetektorvorrichtung und Vorrichtung zur Röntgeninspektion von Produkten, insbesondere von Lebensmitteln', applicationNo: '202010375030.6', status: 'Granted' },
        { no: 10, title: 'Mess-und/oder Sensorvorrichtung mit einer Kamera', applicationNo: '201780085619.9', status: 'Granted' }
      ]
    }
  },
  created() {
  },
  mounted() {
    this.loadTeamMembers()
    // 检查是否有类别查询参数
    this.checkCategoryFromQuery()
    
    // 检查是否需要滚动到团队类别区域
    if (this.$route.query.scrollToCategory === 'true') {
       window.scrollTo(0, 2000);
      // 使用固定延迟时间后直接滚动到指定位置
      setTimeout(() => {
        // 直接滚动到团队类别区域（约1000px位置）
        // window.scrollTo({
        //   top: 3000,
        //   behavior: 'smooth'
        // });
          window.scrollTo(0, 4200);
        console.log('Scrolled to category section using fixed position: 1000px');
        
        // 导航完成后，清除查询参数中的滚动标记，避免刷新页面时再次滚动
        // this.$router.replace({
        //   path: this.$route.path,
        //   query: {
        //     ...this.$route.query,
        //     scrollToCategory: undefined
        //   }
        // });
      }, 10); // 延迟500ms确保页面完全加载
    }
  },
   
  methods: {
    //增加一个获取当前所属语言的回调方法
    getCurrentLanguage() {
      const locale =
        (this.$i18n && this.$i18n.locale) ||
        (this.$root && this.$root.$i18n && this.$root.$i18n.locale) ||
        '';

      if (['zh', 'zh-CN', 'zh-Hans'].includes(locale)) return '中文';
      if (['en', 'en-US', 'en-GB'].includes(locale)) return '英语';
      if (['de', 'de-DE'].includes(locale)) return '德语';

      // 兜底：根据浏览器语言判断
      const lang = (navigator.language || '').toLowerCase();
      if (lang.startsWith('zh')) return '中文';
      if (lang.startsWith('en')) return '英语';
      if (lang.startsWith('de')) return '德语';
      return '中文';
    },

    async loadTeamMembers() {
      console.log("ceshiyyan",this.getCurrentLanguage())
      const categoryToTeam = {
        core: 1,
        patent: 2,
        trademark: 3,
        foreign: 4,
        translation: 5,
        process: 6,
      }
      const current = this.currentCategory
      const teamId = categoryToTeam[current] || 1
      
      var params = {
        pageNum: 1,
        pageSize: 100,
        country: 1,
        team: teamId,
      }
      var ll=this.getCurrentLanguage()
      if(ll=='中文'){
        params.country=1
      }else if(ll=='英语'){
        params.country=3
      }else if(ll=='德语'){
        params.country=2
      }
      console.log("ceshilll1",ll )
       console.log("ceshilll2", params)
     if(teamId==3){
      return;
     }
      // 仅清空当前类别，避免误清空 core；trademark 若不是数组则跳过
      if (current !== 'trademark' && this.teamMembers && this.teamMembers[current]) {
        this.teamMembers[current] = []
      }

      const response = await axios.get('https://api.ipzhixin.com/site/team/member/list', { params })
      const buildImage = (avatar) => {
        if (!avatar) return ''
        if (/^https?:\/\//i.test(avatar)) return avatar
        return 'https://api.ipzhixin.com' + avatar
      }

      if (response.data && response.data.code === 200) {
        const rows = Array.isArray(response.data.rows) ? response.data.rows : []

        // 统一构造成员对象
        const mapped = rows.map(item => ({
          name: item.name,
          title: item.title,
          workLang: JSON.parse(item.workLang),
          coreIntro: JSON.parse(item.coreIntro),
          education: JSON.parse(item.education),
          image: buildImage(item.avatar),
          bisArea: JSON.parse(item.bisArea),
          workExp: JSON.parse(item.workExp),
        }))

        // 仅向当前类别填充
        if (this.teamMembers && this.teamMembers[current]) {
          this.teamMembers[current].push(...mapped)
        }
        console.log("ceshieducation", this.teamMembers)
        this.total = response.data.total || 0
      } else {
        this.$message.error((response.data && response.data.msg) || '获取团队成员失败')
        if (this.teamMembers && this.teamMembers[current]) {
          this.teamMembers[current] = []
        }
        this.total = 0
      }
      console.log('loadTeamMembers response:', response)
    },

    openMemberResume(memberData) {
      console.log("memberData", memberData)


      this.$router.push({
        name: 'TeamUserDetail',
        params: {
          memberData: memberData
        }
      })
    },
    openAnnouncementList(type) {
      if (type == 1) {
        // 在新窗口中打开指定网址
        window.open('https://www.acpaa.cn/front/announcement/list.jhtml', '_blank')
      } else if (type == 2) {
        // 在新窗口中打开指定网址
        window.open('https://www.acpaa.cn/upload/file/202503/32743542-c543-4635-9a99-d18d801a4df8.pdf', '_blank')
      }

    },
    changeTeamCategory(categoryId) {
      // 保存当前滚动位置
      const scrollPosition = window.scrollY;
      
      // 更新当前类别
      this.currentCategory = categoryId
      // 同步更新路由查询参数，保留当前语言前缀与其他查询
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          category: categoryId
        }
      })
      
      // 恢复之前的滚动位置
      setTimeout(() => {
        window.scrollTo(0, scrollPosition);
      }, 0);
      
      // 由 currentCategory 的 watch 统一触发加载，避免重复调用
    },
    // 检查URL查询参数中的类别
    checkCategoryFromQuery() {
      const categoryFromQuery = this.$route.query.category
      if (categoryFromQuery) {
        // 检查类别是否存在
        const categoryExists = this.teamCategories.find(cat => cat.id === categoryFromQuery)
        if (categoryExists) {
          // 仅设置当前类别，加载由 currentCategory 的 watch 触发
          this.currentCategory = categoryFromQuery
        }
      }
    },

    getCurrentTeamMembers() {
      if (this.currentCategory === 'trademark') {
        return [];
      }
      return this.teamMembers[this.currentCategory] || [];
    }
  },
  computed: {
    displayedTeamMembers() {
      return this.getCurrentTeamMembers();
    }
  },
  watch: {
     // 监听语言变化，确保组件响应式更新
    '$i18n.locale'() {
      // 强制更新组件以确保所有翻译文本立即更新
      this.loadTeamMembers()
    },
    currentCategory() {
      this.loadTeamMembers()
    },
    // 监听路由变化，处理类别参数
    '$route.query.category'(newCategory) {
      if (newCategory && newCategory !== this.currentCategory) {
        const categoryExists = this.teamCategories.find(cat => cat.id === newCategory)
        if (categoryExists) {
          // 仅更新当前类别，加载统一由 currentCategory 的 watch 触发
          this.currentCategory = newCategory
        }
      }
    }
  }
}
</script>

<style scoped>
.shangbiaoanlia {
  padding: 6rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.team {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 轮播图部分 */
.banner-section {
  width: 100%;
  position: relative;
  height: 33.6rem;
}

.banner-slide {
  height: 33.6rem;
  background-size: cover;
  background-position: center;
  position: relative;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0);
  /* 完全透明 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 20px;
}

.banner-title {
  font-size: 3.5rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.banner-subtitle {
  font-size: 1.5rem;
  color: #fff;
  margin-bottom: 2rem;
  max-width: 830px;
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.5);
}

/* 自定义 Element UI 轮播图样式 */
.el-carousel__arrow {
  background-color: rgba(255, 99, 30, 0.7);
}

.el-carousel__arrow:hover {
  background-color: rgba(255, 99, 30, 0.9);
}

.el-button--primary {
  background-color: #FF631E;
  border-color: #FF631E;
  padding: 12px 30px;
  font-size: 1.1rem;
}

.el-button--primary:hover {
  background-color: #e55a1b;
  border-color: #e55a1b;
}

/* 公司资质与荣誉样式 */
.company-credentials {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 50%, #fff5f0 100%);
  padding: 2rem 0 0 0;
}

.credentials-header {
  text-align: center;
  margin-bottom: 0rem;
}

.credentials-header .section-title {
  font-size: 2.5rem;
  color: #FF631E;
  margin-bottom: 0rem;
}

.credentials-header .section-subtitle {
  color: #666;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
}

.credentials-content {
  display: grid;
  gap: 3rem;
}

/* 公司介绍卡片 */
.company-intro {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.intro-card {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.intro-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 48px rgba(255, 99, 30, 0.15);
}

.intro-card h3 {
  color: #FF631E;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.intro-card p {
  color: #555;
  line-height: 1.8;
  font-size: 0.95rem;
}

/* 资质认证展示 */
.credentials-showcase {
  /* display: grid; */
  /* grid-template-columns: 1fr 1fr; */
  /* gap: 2rem; */
  margin-top: 50px;
}

.credential-item {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #FF631E;
}

.credential-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.credential-header h3 {
  color: #333;
  font-size: 1.2rem;
  font-weight: 600;
}

.year-badge {
  background: linear-gradient(135deg, #FF631E, #FF7A3D);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.certification-badge {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
}

.credential-content p {
  color: #555;
  line-height: 1.7;
  font-size: 0.95rem;
}

/* 资质证书展示 */
.certificates-display {
  /* display: grid;
  gap: 2rem; */
}

.certificate-card {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
}

.certificate-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #FF631E;
}

.clickable-title {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding: 0.8rem 1rem;
  border-radius: 8px;
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  border: 1px solid rgba(255, 99, 30, 0.2);
  margin-bottom: 1.5rem;
}

.clickable-title:hover {
  color: #FF631E;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  border-color: rgba(255, 99, 30, 0.4);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.15);
}

.clickable-title:active {
  transform: translateY(0);
  box-shadow: 0 4px 15px rgba(255, 99, 30, 0.2);
}

.clickable-title::after {
  content: '🔗';
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.9rem;
  opacity: 0.6;
  transition: opacity 0.3s ease;
}

.clickable-title:hover::after {
  opacity: 1;
}

.certificate-title-bottom {
  font-size: 0.9rem;
  color: #333;
  text-align: center;
}

.certificate-table {
  background: #f8f9fa;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1rem;
}

.table-header {
  display: grid;
  background: #FF631E;
  color: white;
  font-weight: 600;
  font-size: 0.9rem;
}

.table-header span {
  padding: 0.8rem;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.table-header span:last-child {
  border-right: none;
}

.table-row {
  display: grid;
  font-size: 0.85rem;
  border-bottom: 1px solid #dee2e6;
}

.table-row:last-child {
  border-bottom: none;
}

.table-row span {
  padding: 0.7rem 0.8rem;
  border-right: 1px solid #dee2e6;
}

.table-row span:last-child {
  border-right: none;
}

.table-row.highlight {
  background: rgba(255, 99, 30, 0.1);
  font-weight: 600;
  color: #FF631E;
}

/* 表格样式 - 使用独立的class避免互相影响 */

/* 两列表格样式（第一批专利代理机构精准服务保障名单） */
/* 
  修改说明：使用固定宽度确保表头和数据行列宽一致
  - 机构代码：150px 固定宽度
  - 代理机构名称：1fr 占用剩余空间
*/
.two-column-table .table-header {
  grid-template-columns: 150px 1fr;
}

.two-column-table .table-row {
  grid-template-columns: 150px 1fr;
}

/* 五列表格样式（历年资质认证记录） */
/* 
  注意：如果历年资质认证记录表格列数发生变化，需要同时修改以下两个CSS规则
  当前表格有5列：机构代码、负责人、执业许可证号、机构名称、标注
  
  修改方法：
  - 机构代码：120px 固定宽度  
  - 负责人：120px 固定宽度
  - 执业许可证号：180px 固定宽度
  - 机构名称：1fr 占用剩余空间
  - 标注：60px 固定宽度
  
  如需调整列宽，修改对应的像素值或fr值即可
*/
.five-column-table .table-header {
  grid-template-columns: 120px 120px 180px 1fr 60px;
}

.five-column-table .table-row {
  grid-template-columns: 120px 120px 180px 1fr 60px;
}

.certificate-note {
  text-align: center;
  color: #FF631E;
  font-weight: 600;
  font-size: 0.9rem;
  margin-top: 0.5rem;
}

/* 协会认证卡片 */
.association-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-top: 1rem;
}

.association-card {
  background: linear-gradient(135deg, #FF631E, #FF7A3D);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 24px rgba(255, 99, 30, 0.3);
}

.association-card h4 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.association-card p {
  font-size: 0.85rem;
  opacity: 0.9;
}

/* 响应式设计 */
@media (max-width: 992px) {

  .company-intro,
  .credentials-showcase,
  .association-cards {
    grid-template-columns: 1fr;
  }

  .certificate-card:nth-child(2) .table-header,
  .certificate-card:nth-child(2) .table-row {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .certificate-card:nth-child(2) .table-header span,
  .certificate-card:nth-child(2) .table-row span {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
  }
}

@media (max-width: 768px) {
  .company-credentials {
    padding: 3rem 0;
  }

  .credentials-header .section-title {
    font-size: 1.8rem;
  }

  .intro-card,
  .credential-item,
  .certificate-card {
    padding: 1.5rem;
  }

  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .table-header span,
  .table-row span {
    border-right: none;
    border-bottom: 1px solid #dee2e6;
  }
}

/* 团队类别切换按钮样式 */
.team-category-section {
  background-color: #FF631E;
  height: 68px;
  padding: 0;
  display: flex;
  align-items: center;
}

.team-category-buttons {
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
}

.category-btn {
  display: flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.8rem 1.5rem;
  transition: all 0.3s ease;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
}

.category-btn:hover {
  color: #FF631E;
  background-color: white;
}

.category-btn.active {
  color: #FF631E;
  background-color: white;
}

/* 团队成员列表标题 */
.section-title {
  font-size: 1.8rem;
  color: #333;
  text-align: center;
  margin-bottom: 2rem;
  position: relative;
  padding-bottom: 1rem;
}


/* 无成员提示信息 */
.no-members-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: 3rem 0;
  color: #666;
  font-size: 1.2rem;
}

/* 通用样式 */
.container {
  width: 1200px;
  margin: 0 auto;
  padding: 2rem 0;
}

/* 团队成员部分 */
.team-members {
  background-color: white;
  padding: 2rem 0;
}

.team-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.team-card {
  background-color: white;
  display: flex;
  padding: 1rem;
  border-bottom: 1px solid #f0f0f0;
}

.team-image {
  flex: 0 0 130px;
  margin-right: 1.5rem;
}

.member-image {
  width: 100%;
  height: auto;
  object-fit: cover;
}

.team-info {
  flex: 1;
  padding: 0.5rem 0;
}

.member-title {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 0.5rem;
}

.member-subtitle {
  color: #666;
  margin-left: 0.5rem;
}

.member-name {
  font-size: 1.3rem;
  font-weight: 600;
  margin: 0 0 0.8rem 0;
  color: #FF631E;
}

.member-lang {
  font-size: 0.9rem;
  color: #555;
  margin: 0.2rem 0 0.8rem 0;
}

.member-education {
  margin-bottom: 1rem;
}

.member-education p {
  font-size: 0.9rem;
  line-height: 1.5;
  color: #666;
  margin: 0.3rem 0;
}

.member-contact {
  margin-top: 1rem;
}

.contact-btn {
  display: inline-block;
  padding: 0.5rem 1.5rem;
  background-color: #FF631E;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
}

.contact-btn:hover {
  background-color: #e55a1b;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
}

@media (max-width: 992px) {
  .team-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .page-title {
    font-size: 1.8rem;
  }

  .team-card {
    flex-direction: column;
  }

  .team-image {
    flex: 0 0 auto;
    margin-right: 0;
    margin-bottom: 1rem;
    text-align: center;
  }

  .member-image {
    width: 150px;
    height: auto;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 1.6rem;
  }

  .team-info {
    padding: 0;
  }
}

/* 商标团队特殊样式 */
.trademark-team-display {
  max-width: 1000px;
  margin: 0 auto;
}

.trademark-description {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
  margin-bottom: 3rem;
  /* text-align: center; */
  border-left: 4px solid #FF631E;
}

.trademark-description p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #555;
  margin: 0;
}

/* 主图卡片容器与说明 */
.trademark-main-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
  padding: 1.5rem;
  margin-bottom: 3rem;
}

.trademark-caption {
  margin-top: 0.8rem;
  text-align: center;
  color: #444;
  font-weight: 600;
  font-size: 1rem;
  padding-top: 0.6rem;
  border-top: 1px dashed rgba(255, 99, 30, 0.35);
}

/* 原主图网格 */
.trademark-main-images {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
}

.main-image {
  width: 100%;
  height: 400px;
  object-fit: contain;
  border-radius: 12px;
  /* box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1); */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.main-image:hover {
  transform: translateY(-4px);
  /* box-shadow: 0 16px 32px rgba(0, 0, 0, 0.15); */
}

.trademark-gallery {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
}

.gallery-slide {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.gallery-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

/* 商标团队案例模块 */
.trademark-case-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.12);
  padding: 1.8rem;
  margin: 3rem auto;
  max-width: 1000px;
}

.case-title {
  margin: 0 0 1.2rem 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  line-height: 1.5;
  position: relative;
  padding-bottom: 0.6rem;
}



/* 两栏布局：左40% 右56% 中间留4%间距 */
.case-layout {
  display: grid;
  grid-template-columns: 40% 56%;
  column-gap: 4%;
  align-items: start;
}

.case-left {
  width: 100%;
}

.case-image {
  width: 100%;
  height: 440px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: #fafafa;
}

.case-right p {
  margin: 0 0 0.9rem 0;
  color: #555;
  line-height: 1.9;
  font-size: 1rem;
  text-align: justify;
}

/* 平板与手机适配 */
@media (max-width: 992px) {
  .trademark-case-card {
    padding: 1.4rem;
  }

  .case-layout {
    grid-template-columns: 1fr;
    row-gap: 1rem;
  }

  .case-image {
    height: 300px;
    object-fit: contain;
  }

  .case-title {
    font-size: 1.25rem;
  }
}

@media (max-width: 576px) {
  .trademark-case-card {
    padding: 1.1rem;
    border-radius: 12px;
  }

  .case-right p {
    font-size: 0.95rem;
    line-height: 1.8;
  }
}

/* 商标团队国际客户案例模块 */
.trademark-international-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.12);
  padding: 1.8rem;
  margin: 3rem auto;
  max-width: 1000px;
}

/* 复用通用case标题样式 */
.trademark-international-card .case-title {
  margin: 0 0 1.2rem 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  line-height: 1.5;
  position: relative;
  padding-bottom: 0.6rem;
}



/* 九宫格：两行三列 */
.international-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.2rem;
}

.international-item {
  background: #fff;
  border: 1px solid rgba(255, 99, 30, 0.12);
  border-radius: 12px;
  overflow: hidden;
  transition: transform .2s ease, border-color .2s ease;
}

.international-item:hover {
  transform: translateY(-3px);
  border-color: rgba(255, 99, 30, 0.25);
}

.international-image {
  width: 100%;
  height: 200px;
  object-fit: contain;
  background: #fafafa;
}

/* 底部说明文字 */
.international-desc {
  margin-top: 1rem;
  color: #555;
  line-height: 1.9;
  font-size: 1rem;
  text-align: justify;
  padding-top: 0.8rem;
  border-top: 1px dashed rgba(255, 99, 30, 0.35);
}

/* 响应式：平板与手机 */
@media (max-width: 992px) {
  .trademark-international-card {
    padding: 1.4rem;
  }

  .international-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .international-image {
    height: 190px;
  }
}

@media (max-width: 576px) {
  .trademark-international-card {
    padding: 1.1rem;
    border-radius: 12px;
  }

  .international-grid {
    grid-template-columns: 1fr;
  }

  .international-image {
    height: 180px;
  }

  .international-desc {
    font-size: 0.95rem;
    line-height: 1.8;
  }
}

/* 商标团队图片网格样式（替代轮播） */
.trademark-gallery {
  background: #fff;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 8px 8px rgba(0, 0, 0, 0.08);
}

.trademark-gallery-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.2rem;
}

.gallery-card {
  background: #ffffff;
  border: 1px solid rgba(255, 99, 30, 0.12);
  border-radius: 12px;
  overflow: hidden;
  /* box-shadow: 0 4px 16px rgba(0,0,0,0.06); */
  transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.gallery-card:hover {
  transform: translateY(-3px);
  /* box-shadow: 0 10px 24px rgba(0,0,0,0.1); */
  border-color: rgba(255, 99, 30, 0.25);
}

.gallery-image {
  width: 100%;
  height: 220px;
  object-fit: contain;
  /* background: #fafafa; */
}

.gallery-caption {
  margin-top: 1rem;
  text-align: center;
  color: #444;
  font-weight: 600;
  font-size: 1rem;
  padding-top: 0.6rem;
  border-top: 1px dashed rgba(255, 99, 30, 0.35);
}

/* 响应式：平板与手机 */
@media (max-width: 992px) {
  .trademark-gallery-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .gallery-image {
    height: 200px;
  }
}

@media (max-width: 576px) {
  .trademark-gallery-grid {
    grid-template-columns: 1fr;
  }

  .gallery-image {
    height: 180px;
  }
}

/* 自定义轮播图样式 */
.trademark-gallery .el-carousel__arrow {
  background-color: rgba(255, 99, 30, 0.8);
  width: 50px;
  height: 50px;
}

.trademark-gallery .el-carousel__arrow:hover {
  background-color: rgba(255, 99, 30, 1);
}

.trademark-gallery .el-carousel__arrow--left {
  left: 20px;
}

.trademark-gallery .el-carousel__arrow--right {
  right: 20px;
}

.trademark-gallery .el-carousel__indicator {
  background-color: rgba(255, 99, 30, 0.3);
}

.trademark-gallery .el-carousel__indicator.is-active {
  background-color: #FF631E;
}

/* 商标团队响应式设计 */
@media (max-width: 768px) {
  .trademark-main-images {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .main-image {
    height: 200px;
  }

  .trademark-description {
    padding: 1.5rem;
  }

  .trademark-gallery {
    padding: 1rem;
  }

  .gallery-slide {
    height: 200px;
  }
}

/* 团队荣誉展示样式 */
.team-honors-section {
  padding: 1rem 0;
  background-color: #FFF5F0;
}

.honors-header {
  text-align: center;
  margin-bottom: 2rem;
}

.honors-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

/* 荣誉展示卡片 */
.honors-showcase {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.honor-item {
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
}

.honor-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.12);
}

.honor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2rem 1rem 2rem;
  border-bottom: 1px solid #f0f0f0;
}

.honor-header h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.year-range-badge {
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(255, 99, 30, 0.3);
}

.honor-content {
  padding: 2rem;
}

.honor-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.honor-entry {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem;
  background: linear-gradient(135deg, #ffffff, #fafafa);
  border-radius: 12px;
  border-left: 4px solid #FF631E;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.honor-entry:hover {
  background: #fff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-left-color: #ff8c42;
}

.honor-year {
  flex-shrink: 0;
  width: 80px;
  font-weight: 700;
  color: #FF631E;
  font-size: 1.1rem;
  margin-left: 1rem;
  text-align: center;
  background: rgba(255, 99, 30, 0.1);
  padding: 0.5rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 99, 30, 0.2);
}

.honor-text {
  flex: 1;
  color: #444;
  font-size: 1.05rem;
  line-height: 1.7;
  font-weight: 500;
}

/* PC端优化 */
@media (min-width: 769px) {

  /* 适用于PC和较大平板 */
  .honor-entry {
    background: none;
    /* 移除单个条目的背景 */
    box-shadow: none;
    /* 移除单个条目的阴影 */
    border-radius: 0;
    /* 移除单个条目的圆角 */
    padding: 1rem 0;
    /* 调整内边距，使其更像列表项 */
    border-left: 4px solid #FF631E;
    /* 保留左侧边框 */
  }

  .honor-entry:hover {
    background: rgba(255, 99, 30, 0.05);
    /* 悬停时添加微妙背景 */
    box-shadow: none;
    transform: none;
    /* 移除悬停时的形变效果 */
    border-left-color: #ff8c42;
  }

  .honor-year {
    width: 70px;
    /* 调整年份宽度 */
    margin-right: 1.5rem;
    background: none;
    /* 移除年份背景 */
    border: none;
    /* 移除年份边框 */
    padding: 0;
    /* 移除年份内边距 */
    text-align: left;
    /* 年份左对齐 */
    font-size: 1rem;
    /* 调整字体大小 */
    color: #FF631E;
    /* 保持颜色 */
  }

  .honor-text {
    font-size: 1rem;
    line-height: 1.6;
    color: #444;
    /* 保持颜色 */
  }
}

/* 针对超大屏幕PC端进一步优化 */
@media (min-width: 1200px) {
  .honor-entry {
    padding: 0.5rem 0;
  }

  .honor-year {
    width: 80px;
    font-size: 1.1rem;
    margin-left: 1rem;
  }

  .honor-text {
    font-size: 1.05rem;
    line-height: 1.7;
  }
}

/* 移动端适配 */
@media (max-width: 768px) {
  .team-honors-section {
    padding: 2rem 0;
  }

  .honors-content {
    padding: 0 1rem;
  }

  .honor-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
    padding: 1.5rem;
  }

  .honor-header h3 {
    font-size: 1.3rem;
  }

  .honor-content {
    padding: 1.5rem;
  }

  .honor-entry {
    flex-direction: column;
    gap: 0.8rem;
    padding: 0.5rem;
    align-items: flex-start;
  }

  .honor-year {
    width: auto;
    margin-right: 0;
    margin-bottom: 0.5rem;
    text-align: left;
    padding: 0.4rem 0.8rem;
    font-size: 0.95rem;
  }

  .honor-text {
    font-size: 0.95rem;
    line-height: 1.6;
    margin-left: 0;
  }
}

@media (max-width: 576px) {
  .honors-content {
    padding: 0 0.5rem;
  }

  .honor-header {
    padding: 1rem;
  }

  .honor-header h3 {
    font-size: 1.2rem;
  }

  .year-range-badge {
    font-size: 0.8rem;
    padding: 0.4rem 0.8rem;
  }

  .honor-content {
    padding: 1rem;
  }

  .honor-entry {
    padding: 1rem;
  }

  .honor-year {
    font-size: 0.9rem;
    padding: 0.3rem 0.6rem;
  }

  .honor-text {
    font-size: 0.9rem;
    line-height: 1.5;
  }
}

/* 翻译团队概况样式 */
.translation-overview-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

.translation-overview-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 3rem;
  border: 1px solid rgba(255, 99, 30, 0.1);
  max-width: 1200px;
  margin: 0 auto;
}

.overview-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin-bottom: 2.5rem;
  position: relative;
  padding-bottom: 1rem;
}

.overview-title::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 80px;
  height: 4px;
  border-radius: 2px;
}

/* 团队基本信息网格 */
.team-basic-info {
  margin-bottom: 3rem;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  margin-bottom: 2rem;
}

.info-item {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  padding: 1.5rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.info-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(255, 99, 30, 0.15);
  border-color: rgba(255, 99, 30, 0.2);
}

.info-icon {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1.5rem;
  box-shadow: 0 8px 20px rgba(255, 99, 30, 0.3);
}

.icon-number {
  font-size: 1.5rem;
  font-weight: 700;
  color: white;
}

.info-content h4 {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 0.5rem 0;
}

.info-content p {
  font-size: 0.95rem;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.highlight-text {
  color: #FF631E;
  font-weight: 600;
}

/* 团队组成说明 */
.team-composition {
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 1.5rem;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.25);
}

.composition-text {
  font-size: 1.1rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.6;
}

/* 专业能力介绍 */
.professional-capabilities {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.capability-item {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  padding: 2rem;
  border-radius: 16px;
  border-left: 5px solid #FF631E;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.capability-item:hover {
  transform: translateX(5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.capability-header h4 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 1rem 0;
}

.capability-content p {
  font-size: 1.05rem;
  color: #555;
  line-height: 1.8;
  margin: 0;
}

/* 语言标签 */
.language-tag {
  display: inline-block;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 15px;
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0 0.2rem;
}

/* 高亮数字 */
.highlight-number {
  color: #FF631E;
  font-weight: 700;
  font-size: 1.1em;
}



/* 响应式设计 */
@media (max-width: 992px) {
  .translation-overview-section {
    padding: 3rem 0;
  }

  .translation-overview-card {
    padding: 2rem;
    margin: 0 1rem;
  }

  .info-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .overview-title {
    font-size: 1.8rem;
  }
}

@media (max-width: 768px) {
  .translation-overview-section {
    padding: 2rem 0;
  }

  .translation-overview-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .info-item {
    flex-direction: column;
    text-align: center;
    padding: 1.2rem;
  }

  .info-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }

  .overview-title {
    font-size: 1.6rem;
    margin-bottom: 2rem;
  }

  .capability-item {
    padding: 1.5rem;
  }

  .capability-header h4 {
    font-size: 1.2rem;
  }

  .capability-content p {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .translation-overview-card {
    padding: 1rem;
    margin: 0 0.5rem;
  }

  .overview-title {
    font-size: 1.4rem;
  }

  .info-icon {
    width: 50px;
    height: 50px;
  }

  .icon-number {
    font-size: 1.3rem;
  }

  .info-content h4 {
    font-size: 1rem;
  }

  .info-content p {
    font-size: 0.9rem;
  }

  .composition-text {
    font-size: 1rem;
  }

  .capability-header h4 {
    font-size: 1.1rem;
  }

  .capability-content p {
    font-size: 0.95rem;
  }
}

/* 翻译服务内容样式 */
.translation-services-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.services-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
}

.service-category-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.service-category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(255, 99, 30, 0.15);
}

.category-header {
  text-align: center;
  margin-bottom: 2rem;
}

.category-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 1rem 0;
}



/* 专利翻译服务网格 */
.service-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.service-column {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.service-item {
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  padding: 1rem 1.2rem;
  border-radius: 12px;
  border-left: 4px solid #FF631E;
  font-size: 0.95rem;
  color: #555;
  line-height: 1.4;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.service-item:hover {
  transform: translateX(5px);
  background: white;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.1);
  border-left-color: #ff8c42;
}

/* 翻译语言部分 */
.languages-section {
  border-top: 1px dashed rgba(255, 99, 30, 0.3);
  padding-top: 1.5rem;
  text-align: center;
}

.languages-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 1rem 0;
}

.languages-tags {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.language-tag.primary {
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 0.6rem 1.5rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.language-tag.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 30px rgba(255, 99, 30, 0.4);
}

/* 本地化流程网格 */
.localization-grid {
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}

.localization-item {
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  padding: 1.2rem;
  border-radius: 15px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.localization-item:hover {
  transform: translateX(8px);
  background: white;
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.12);
  border-color: rgba(255, 99, 30, 0.2);
}

.step-number {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 1.1rem;
  margin-right: 1.2rem;
  box-shadow: 0 4px 15px rgba(255, 99, 30, 0.3);
}

.step-content {
  font-size: 1.05rem;
  color: #555;
  font-weight: 500;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .services-layout {
    gap: 2rem;
    margin: 0 1rem;
  }

  .service-category-card {
    padding: 2rem;
  }
}

@media (max-width: 992px) {
  .translation-services-section {
    padding: 3rem 0;
  }

  .services-layout {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    margin: 0 1rem;
  }

  .service-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .category-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 768px) {
  .translation-services-section {
    padding: 2rem 0;
  }

  .service-category-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .category-title {
    font-size: 1.3rem;
  }

  .service-item {
    padding: 0.8rem 1rem;
    font-size: 0.9rem;
  }

  .localization-item {
    padding: 1rem;
  }

  .step-number {
    width: 35px;
    height: 35px;
    font-size: 1rem;
    margin-right: 1rem;
  }

  .step-content {
    font-size: 1rem;
  }

  .languages-tags {
    flex-direction: column;
    align-items: center;
  }

  .language-tag.primary {
    padding: 0.5rem 1.2rem;
    font-size: 0.95rem;
  }
}

@media (max-width: 576px) {
  .services-layout {
    margin: 0 0.5rem;
  }

  .service-category-card {
    padding: 1.2rem;
  }

  .category-title {
    font-size: 1.2rem;
  }

  .service-item {
    padding: 0.7rem 0.8rem;
    font-size: 0.85rem;
  }

  .localization-item {
    padding: 0.8rem;
    flex-direction: column;
    text-align: center;
  }

  .step-number {
    margin-right: 0;
    margin-bottom: 0.5rem;
  }

  .step-content {
    font-size: 0.95rem;
  }

  .languages-title {
    font-size: 1.1rem;
  }
}

/* 翻译团队客户展示样式 */
.translation-clients-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
}

/* 主标题样式 */
.clients-main-header {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 1rem 0;
}



.clients-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
}

.client-category-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.client-category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(255, 99, 30, 0.15);
}

.client-category-card .category-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.client-category-card .category-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  margin: 0 0 1rem 0;
}

.client-category-card .category-underline {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  margin: 0 auto;
  border-radius: 2px;
}

/* 客户网格布局 */
.clients-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}

.client-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%); */
  padding: 1.5rem 1rem;
  border-radius: 16px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.client-item:hover {
  transform: translateY(-8px);
  background: white;
  box-shadow: 0 12px 30px rgba(255, 99, 30, 0.15);
  border-color: rgba(255, 99, 30, 0.2);
}

.client-logo {
  width: 80px;
  height: 80px;
  background: white;
  /* border-radius: 50%; */
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-bottom: 1rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  border: 2px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease; */
}



.logo-image {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.client-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: #555;
  text-align: center;
  line-height: 1.3;
}

.client-item:hover .client-name {
  color: #FF631E;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .clients-layout {
    gap: 2rem;
    margin: 0 1rem;
  }

  .client-category-card {
    padding: 2rem;
  }

  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.2rem;
  }
}

@media (max-width: 992px) {
  .translation-clients-section {
    padding: 3rem 0;
  }

  .clients-layout {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    margin: 0 1rem;
  }

  .clients-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }

  .client-category-card .category-title {
    font-size: 1.5rem;
  }
}

@media (max-width: 768px) {
  .translation-clients-section {
    padding: 2rem 0;
  }

  .main-title {
    font-size: 2rem;
  }

  .clients-main-header {
    margin-bottom: 2rem;
  }

  .client-category-card {
    padding: 1.5rem;
    border-radius: 16px;
  }

  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }

  .client-item {
    padding: 1.2rem 0.8rem;
  }

  .client-logo {
    width: 70px;
    height: 70px;
  }

  .logo-image {
    width: 45px;
    height: 45px;
  }

  .client-name {
    font-size: 0.9rem;
  }

  .client-category-card .category-title {
    font-size: 1.4rem;
  }
}

@media (max-width: 576px) {
  .main-title {
    font-size: 1.8rem;
  }

  .clients-layout {
    margin: 0 0.5rem;
  }

  .client-category-card {
    padding: 1.2rem;
  }

  .clients-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.8rem;
  }

  .client-item {
    padding: 1rem 0.6rem;
  }

  .client-logo {
    width: 60px;
    height: 60px;
    margin-bottom: 0.8rem;
  }

  .logo-image {
    width: 40px;
    height: 40px;
  }

  .client-name {
    font-size: 0.85rem;
  }

  .client-category-card .category-title {
    font-size: 1.3rem;
  }

  .client-category-card .category-header {
    margin-bottom: 2rem;
  }
}

@media (max-width: 480px) {
  .clients-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .client-item {
    flex-direction: row;
    text-align: left;
    padding: 1rem;
  }

  .client-logo {
    margin-right: 1rem;
    margin-bottom: 0;
    flex-shrink: 0;
  }

  .client-name {
    text-align: left;
    flex: 1;
    display: flex;
    align-items: center;
  }
}

/* WIPOTEC合作案例样式 */
.wipotec-case-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.wipotec-case-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
  padding: 3rem;
  margin: 0 auto;
  max-width: 1200px;
}

.wipotec-case-card .case-title {
  margin: 0 0 2rem 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  line-height: 1.4;
  text-align: center;
  position: relative;
  padding-bottom: 1rem;
}



/* 案例布局：左右分栏 */
.case-layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 3rem;
  align-items: start;
  margin-bottom: 3rem;
}

.case-left {
  display: flex;
  justify-content: center;
}

.company-logo-container {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.company-logo-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 5px rgba(255, 99, 30, 0.15);
}

.company-logo {
  width: 100%;
  height: auto;
  max-width: 250px;
  object-fit: contain;
}

.case-right {
  flex: 1;
}

.company-intro p {
  margin: 0 0 1.5rem 0;
  color: #555;
  line-height: 1.8;
  font-size: 1.05rem;
  text-align: justify;
}

.company-intro p:last-child {
  margin-bottom: 0;
}

.highlight-text {
  color: #FF631E;
  font-weight: 600;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
}

/* 专利列表样式 */
.patents-section {
  border-top: 2px dashed rgba(255, 99, 30, 0.3);
  padding-top: 2rem;
}

.patents-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin: 0 0 2rem 0;
  position: relative;
  padding-bottom: 0.8rem;
}

.patents-title::after {}

.patents-table-container {
  overflow-x: auto;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.patents-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  font-size: 0.95rem;
}

.patents-table thead {
  background: linear-gradient(135deg, #FF631E 0%, #e55a1a 100%);
  color: white;
}

.patents-table th {
  padding: 1.2rem 1rem;
  text-align: center;
  font-weight: 600;
  font-size: 1rem;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.patents-table th:last-child {
  border-right: none;
}

.patents-table tbody tr {
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.patents-table tbody tr:hover {
  background: rgba(255, 99, 30, 0.05);
}

.patents-table tbody tr:last-child {
  border-bottom: none;
}

.patents-table td {
  padding: 1rem;
  text-align: center;
  color: #555;
  border-right: 1px solid #f0f0f0;
}

.patents-table td:last-child {
  border-right: none;
}

/* 表格列宽设置 */
.patents-table .col-no {
  width: 8%;
}

.patents-table .col-title {
  width: 50%;
  text-align: left !important;
}

.patents-table .col-application {
  width: 25%;
}

.patents-table .col-status {
  width: 17%;
}

.status-badge {
  display: inline-block;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-badge.granted {
  background: linear-gradient(135deg, #28a745, #20c997);
  color: white;
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .wipotec-case-card {
    padding: 2.5rem;
    margin: 0 1rem;
  }

  .case-layout {
    grid-template-columns: 250px 1fr;
    gap: 2rem;
  }
}

@media (max-width: 992px) {
  .wipotec-case-section {
    padding: 3rem 0;
  }

  .case-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .company-logo-container {
    max-width: 300px;
    margin: 0 auto;
  }

  .wipotec-case-card .case-title {
    font-size: 1.4rem;
  }

  .patents-title {
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .wipotec-case-section {
    padding: 2rem 0;
  }

  .wipotec-case-card {
    padding: 2rem;
    border-radius: 16px;
  }

  .wipotec-case-card .case-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .company-intro p {
    font-size: 1rem;
    line-height: 1.7;
  }

  .patents-table {
    font-size: 0.9rem;
  }

  .patents-table th,
  .patents-table td {
    padding: 0.8rem 0.5rem;
  }

  .patents-title {
    font-size: 1.2rem;
  }
}

@media (max-width: 576px) {
  .wipotec-case-card {
    padding: 1.5rem;
  }

  .wipotec-case-card .case-title {
    font-size: 1.2rem;
  }

  .company-logo-container {
    padding: 1.5rem;
  }

  .company-intro p {
    font-size: 0.95rem;
  }

  .patents-table {
    font-size: 0.85rem;
  }

  .patents-table th,
  .patents-table td {
    padding: 0.6rem 0.3rem;
  }

  .status-badge {
    padding: 0.3rem 0.8rem;
    font-size: 0.8rem;
  }

  /* 移动端表格优化 */
  .patents-table-container {
    margin: 0 -0.5rem;
  }
}

/* 华中科技大学合作案例样式 */
.hust-case-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
}

.hust-case-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
  padding: 3rem;
  margin: 0 auto;
  max-width: 1200px;
}

.hust-case-card .case-title {
  margin: 0 0 2rem 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  line-height: 1.4;
  text-align: center;
  position: relative;
  padding-bottom: 1rem;
}



/* 案例布局：左右分栏 */
.hust-case-card .case-layout {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 3rem;
  align-items: start;
  margin-bottom: 3rem;
}

.hust-case-card .case-left {
  display: flex;
  justify-content: center;
}

.university-logo-container {
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 0px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
}

.university-logo-container:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 5px rgba(255, 99, 30, 0.15);
}

.university-logo {
  width: 100%;
  height: auto;
  max-width: 250px;
  object-fit: contain;
}

.hust-case-card .case-right {
  flex: 1;
}

.university-intro p {
  margin: 0 0 1.5rem 0;
  color: #555;
  line-height: 1.8;
  font-size: 1.05rem;
  text-align: justify;
}

.university-intro p:last-child {
  margin-bottom: 0;
}

.highlight-badge {
  display: inline-block;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  color: white;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0 0.2rem;
}

.highlight-year {
  color: #FF631E;
  font-weight: 700;
  font-size: 1.1rem;
}

.highlight-rate {
  color: #FF631E;
  font-weight: 700;
  background: rgba(255, 99, 30, 0.1);
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  font-size: 1.1rem;
}

/* 合作成果统计样式 */
.cooperation-stats {
  border-top: 2px dashed rgba(255, 99, 30, 0.3);
  padding-top: 2rem;
}

.stats-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #333;
  text-align: center;
  margin: 0 0 2rem 0;
  position: relative;
  padding-bottom: 0.8rem;
}



.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.stat-item {
  text-align: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg, #fff5f0 0%, #ffffff 100%);
  border-radius: 16px;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.stat-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
}

.stat-item:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 35px rgba(255, 99, 30, 0.15);
}

.stat-number {
  font-size: 2.2rem;
  font-weight: 700;
  color: #FF631E;
  margin-bottom: 0.5rem;
  line-height: 1;
}

.stat-label {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
  line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .hust-case-card {
    padding: 2.5rem;
    margin: 0 1rem;
  }

  .hust-case-card .case-layout {
    grid-template-columns: 250px 1fr;
    gap: 2rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 992px) {
  .hust-case-section {
    padding: 3rem 0;
  }

  .hust-case-card .case-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
    text-align: center;
  }

  .university-logo-container {
    max-width: 300px;
    margin: 0 auto;
  }

  .hust-case-card .case-title {
    font-size: 1.4rem;
  }

  .stats-title {
    font-size: 1.3rem;
  }

  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .hust-case-section {
    padding: 2rem 0;
  }

  .hust-case-card {
    padding: 2rem;
    border-radius: 16px;
  }

  .hust-case-card .case-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .university-intro p {
    font-size: 1rem;
    line-height: 1.7;
  }

  .stats-title {
    font-size: 1.2rem;
  }

  .stat-number {
    font-size: 1.8rem;
  }

  .stat-label {
    font-size: 0.9rem;
  }
}

@media (max-width: 576px) {
  .hust-case-card {
    padding: 1.5rem;
  }

  .hust-case-card .case-title {
    font-size: 1.2rem;
  }

  .university-logo-container {
    padding: 1.5rem;
  }

  .university-intro p {
    font-size: 0.95rem;
  }

  .stats-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .stat-item {
    padding: 1.5rem 1rem;
  }

  .stat-number {
    font-size: 1.6rem;
  }

  .highlight-badge {
    font-size: 0.8rem;
    padding: 0.15rem 0.4rem;
  }
}

/* 翻译客户反馈样式 */
.feedback-section {
  padding: 4rem 0;
  background: linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%);
}

.feedback-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 99, 30, 0.1);
  padding: 3rem;
  margin: 0 auto;
  max-width: 1200px;
}

.feedback-title {
  margin: 0 0 2rem 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #333;
  line-height: 1.4;
  text-align: center;
  position: relative;
  padding-bottom: 1rem;
}


/* 反馈布局：左右分栏 */
.feedback-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: start;
}

.feedback-left,
.feedback-right {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.feedback-item {
  background: linear-gradient(135deg, #fff9f5 0%, #ffffff 100%);
  border-radius: 16px;
  padding: 2rem;
  border: 1px solid rgba(255, 99, 30, 0.1);
  transition: all 0.3s ease;
  position: relative;
}

.feedback-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(255, 99, 30, 0.1);
}

.feedback-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid rgba(255, 99, 30, 0.1);
}

.feedback-company-icon {
  width: 12px;
  height: 12px;
  background: linear-gradient(135deg, #FF631E, #ff8c42);
  border-radius: 50%;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 0.8rem;
}

.feedback-company-name {
  font-size: 1.2rem;
  font-weight: 700;
  color: #333;
  margin: 0;
}

.feedback-content {
  line-height: 1.8;
}

.feedback-text-de {
  color: #666;
  font-style: italic;
  margin: 0 0 0.8rem 0;
  font-size: 1rem;
  line-height: 1.7;
}

.feedback-text-cn {
  color: #555;
  margin: 0 0 1.2rem 0;
  font-size: 1rem;
  line-height: 1.8;
}

.feedback-text-cn:last-child {
  margin-bottom: 0;
}

.feedback-highlight {
  color: #FF631E;
  font-weight: 600;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
}

/* 右侧特殊样式 */
.feedback-right .feedback-item {
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
  border-left: 4px solid #FF631E;
}

.feedback-right .feedback-text-cn {
  font-size: 1.05rem;
  text-align: justify;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .feedback-card {
    padding: 2.5rem;
    margin: 0 1rem;
  }

  .feedback-layout {
    gap: 2rem;
  }
}

@media (max-width: 992px) {
  .feedback-section {
    padding: 3rem 0;
  }

  .feedback-layout {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .feedback-title {
    font-size: 1.4rem;
  }

  .feedback-item {
    padding: 1.5rem;
  }
}

@media (max-width: 768px) {
  .feedback-section {
    padding: 2rem 0;
  }

  .feedback-card {
    padding: 2rem;
    border-radius: 16px;
  }

  .feedback-title {
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
  }

  .feedback-left,
  .feedback-right {
    gap: 1.5rem;
  }

  .feedback-item {
    padding: 1.5rem;
  }

  .feedback-text-de,
  .feedback-text-cn {
    font-size: 0.95rem;
  }

  .feedback-company-name {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .feedback-card {
    padding: 1.5rem;
  }

  .feedback-title {
    font-size: 1.2rem;
  }

  .feedback-item {
    padding: 1.2rem;
  }

  .feedback-header {
    margin-bottom: 1rem;
    padding-bottom: 0.8rem;
  }

  .feedback-company-name {
    font-size: 1rem;
  }

  .feedback-text-de,
  .feedback-text-cn {
    font-size: 0.9rem;
    line-height: 1.6;
  }

  .feedback-highlight {
    padding: 0.15rem 0.3rem;
    font-size: 0.9rem;
  }
}

/* 可点击标题移动端适配 */
@media (max-width: 768px) {
  .clickable-title {
    padding: 0.6rem 0.8rem;
    font-size: 1.1rem;
    margin-bottom: 1.2rem;
  }

  .clickable-title::after {
    right: 0.8rem;
    font-size: 0.8rem;
  }
}

@media (max-width: 576px) {
  .clickable-title {
    padding: 0.5rem 0.6rem;
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  .clickable-title::after {
    right: 0.6rem;
    font-size: 0.7rem;
  }
}
</style>